<template>
  <v-app id="app">
    <header>
      <div class="wrap">
        <a href="/servicemap" class="logo"></a>

      </div>
    </header>
    <router-view/>
  </v-app>
</template>

<style lang="scss">
@import "./styles/main.scss";
</style>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>



<script>
export default {
  props: {
  },
  data() {
    return {
      logoutOptions: null,
      notificationsCount: null,
    };
  },
  methods: {
  },

  async beforeMount() {
    this.logoutOptions = {redirectUri: window.location.origin};
  }
};
</script>
